const moduleSel = (state: any) => state.user;

export const userSel = (state: any) => moduleSel(state).user;
export const userDataSel = (state: any) => moduleSel(state).userData;
export const accountIdSel = (state: any) => userDataSel(state).accountId;
export const accountsSel = (state: any) => moduleSel(state).accounts;
export const accountsPaginationSel = (state: any) =>
  moduleSel(state).accountsPagination;
export const accountsIsPendingSel = (state: any) =>
  moduleSel(state).getUserAccountsIsPending;
export const accountSpecialUserSel = (state: any) =>
  moduleSel(state).userData.specialUser;
export const accountErrorSel = (state: any) => moduleSel(state).error;
export const emailUpdateSel = (state: any) => moduleSel(state).emailUpdated;
